import { graphql } from '../gql';

export const getVendorPermissions = graphql(`
  query getVendorPermissions($userId: ID!, $domains: [DomainEnum!] = [], $entityType: String = "") {
    getUser(id: $userId) {
      user {
        id
        permissions: permissions(entityType: $entityType, domains: $domains) {
          domain
          entityId
          entityType
        }
      }
    }
  }
`);
